import Hero from '../components/Hero';
import About from '../components/About';
import Trainers from '../components/Trainer';
import Media from '../components/Media';
import PlanCarousel from '../components/PlanCarousel';
import ReviewForm from '../components/ReviewForm';
import ReviewList from '../components/ReviewList';
import ContactForm from '../components/ContactForm';
import SectionHeader from "../components/SectionHeader";
import SectionWrapper from "../components/SectionWrapper"; // ✅ NEW
import { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_BASE_URL } from '../utils';

const studentPlans = [
  
  { duration: '3 Months', monthlyFee: 1800, admissionFee: null },
  { duration: '6 Months', monthlyFee: 3500, admissionFee: null },
  { duration: '12 Months', monthlyFee: 6000, admissionFee: null },
  { duration: '1 Month', monthlyFee: 600, admissionFee: 1000 },
  { duration: '1 Day', monthlyFee: 60, admissionFee: null },
  { duration: '7 Days', monthlyFee: 600, admissionFee: null },
  { duration: '15 Days', monthlyFee: 800, admissionFee: null },
];

const nonStudentPlans = [
  
  { duration: '3 Months', monthlyFee: 2000, admissionFee: null },
  { duration: '6 Months', monthlyFee: 3800, admissionFee: null },
  { duration: '12 Months', monthlyFee: 7000, admissionFee: null },
  { duration: '1 Month', monthlyFee: 700, admissionFee: 1000 },
  { duration: '1 Day', monthlyFee: 70, admissionFee: null },
  { duration: '7 Days', monthlyFee: 800, admissionFee: null },
  { duration: '15 Days', monthlyFee: 1000, admissionFee: null },
];

const personalTraining = [
  { description: '6 Classes', fee: 2000 },
  { description: '8 Classes', fee: 3000 },
];

const Home = () => {
  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [activeCategory, setActiveCategory] = useState('students');
  const [showReviewForm, setShowReviewForm] = useState(false);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/reviews`);
      setReviews(res.data);
      const avg = res.data.reduce((sum, r) => sum + r.rating, 0) / res.data.length || 0;
      setAverageRating(avg.toFixed(1));
    } catch (err) {
      toast.error('Failed to load reviews');
    }
  };

  const addReview = (newReview) => {
    setReviews([newReview, ...reviews]);
    fetchReviews();
    setShowReviewForm(false);
  };

  return (
    <div className="pt-16 relative">
      <section id="home" className='bg-slate-100'>
        <Hero />
      </section>

      {/* About Section */}
      <SectionWrapper animation="fade-up" id="about" className='bg-slate-100'>
        <SectionHeader
          background="ABOUT US"
          foreground="WE NOT JUST BUILD STRONG BODY BUT ALSO A STRONG MIND"
        />
        <About />
      </SectionWrapper>

      {/* Trainers Section */}
      <SectionWrapper animation="fade-right" id="trainers" className='bg-slate-100'>
        <SectionHeader background="TRAINERS" foreground="OUR TEAM" />
        <Trainers />
      </SectionWrapper>

      {/* Facility Section */}
      <SectionWrapper animation="zoom-in" id="facility" className="bg-slate-100">
        <SectionHeader background="FACILITY" foreground="YOU CAN ACCESS" />
        {/* Add your facility component/content here */}
        <Media />
      </SectionWrapper>

      

      {/* Membership Plans */}
      <SectionWrapper animation="fade-left" id="plans" className="bg-slate-100">
        <SectionHeader background="MEMBERSHIPS" foreground="WHAT WE OFFER" />
        <div className="flex justify-center space-x-4 mb-8">
          <button
            onClick={() => setActiveCategory('students')}
            className={`px-4 py-2 rounded-lg ${activeCategory === 'students' ? 'bg-primary-950 text-white' : 'bg-slate-200 text-slate-800'}`}
          >
            Students
          </button>
          <button
            onClick={() => setActiveCategory('non-students')}
            className={`px-4 py-2 rounded-lg ${activeCategory === 'non-students' ? 'bg-primary-950 text-white' : 'bg-slate-200 text-slate-800'}`}
          >
            Non-Students
          </button>
          <button
            onClick={() => setActiveCategory('personal-training')}
            className={`px-4 py-2 rounded-lg ${activeCategory === 'personal-training' ? 'bg-primary-950 text-white' : 'bg-slate-200 text-slate-800'}`}
          >
            Personal Training
          </button>
        </div>
        {activeCategory === 'students' && <PlanCarousel plans={studentPlans} isStudent={true} />}
        {activeCategory === 'non-students' && <PlanCarousel plans={nonStudentPlans} isStudent={false} />}
        {activeCategory === 'personal-training' && <PlanCarousel plans={personalTraining} isPersonalTraining={true} />}
      </SectionWrapper>

      {/* Reviews Section */}
      <SectionWrapper animation="fade-up" id="reviews" className="bg-slate-100">
        <SectionHeader background="REVIEWS" foreground="WHAT OUR CLIENTS SAY" />
        {showReviewForm && (
          <div className="backdrop">
            <ReviewForm onAdd={addReview} onClose={() => setShowReviewForm(false)} />
          </div>
        )}
        <ReviewList reviews={reviews} />
      </SectionWrapper>

      {/* Contact Section */}
      <SectionWrapper animation="fade-up" id="contact" className="bg-slate-100">
        <SectionHeader background="CONTACT US" foreground="GET IN TOUCH" />
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <p>Address: Sindhisar Amlighat, Morigaon, Assam</p>
            <p>Phone: 7002974434 / 8011764617</p>
            <p>Email: info@fitgym.com</p>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d804.089785054256!2d92.27389547736573!3d26.129190900944284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375ac5002a13d29f%3A0xb424bf7e4f92ea10!2sPower%20and%20Pump%20Fitness%20Forge%20Gym!5e1!3m2!1sen!2sin!4v1757579751528!5m2!1sen!2sin"
              width="100%" height="300" className="mt-4" allowFullScreen="" loading="lazy"
            ></iframe>
          </div>
          <ContactForm />
        </div>
      </SectionWrapper>

      {/* Floating Review Button */}
      <button
        onClick={() => setShowReviewForm(!showReviewForm)}
        className="fixed bottom-8 right-8 bg-primary-950 text-white px-6 py-3 rounded-full shadow-lg hover:bg-primary/90 z-50"
      >
        {showReviewForm ? 'Close Form' : 'Leave a Review'}
      </button>
    </div>
  );
};

export default Home;
